import React, { useEffect } from "react";

import useLayoutStore from "stores/useLayoutStore";
import { Error500 } from "containers/Error/Error500";
const Error500page = () => {
  const { setLayout } = useLayoutStore();

  useEffect(() => {
    setLayout({ isHeader: false, isSubTab: false });
  }, []);
  return (
    <>
      <Error500 />
    </>
  );
};

export default Error500page;
